// @flow

import React from 'react';
import ReactDOM, { hydrate, render } from 'react-dom';
import makeScheduleAPIClient from './APIClient';
import App from "./App";
import {getDocument, getWindow, isSafari10} from "../Helpers/browsers";
import makeShowAPIClient from "../ShowPage/APIClient";
import Fallback from './components/Fallback';

getWindow().then(window => {
  getDocument().then(document => {
    if (isSafari10()) {
      let root = document.getElementById('schedule-outer');

      if (root) {
        render(<Fallback/>, root);
      }
    } else {
      let root = document.getElementById('schedule-v2');

      if (root) {
        let { year, month, date, scheduleAPIUrl, channel } = window.schedule;

        let showAPIClient = makeShowAPIClient();
        let scheduleAPIClient = makeScheduleAPIClient(scheduleAPIUrl);


        scheduleAPIClient
          .getSchedule(year, month + 1, date, 30)
          .then(schedule => {
            hydrate(
              <App
                current={{year, month, date}}
                schedule={schedule}
                showClient={() => showAPIClient}
                scheduleClient={() => scheduleAPIClient}
                channel={channel === null ? 'TPT2' : channel}
              />,
              root
            );
          });
      }
    }
  });
});